import React from 'react';
import { Table, Button, TabPane } from 'reactstrap';
import { Download } from 'react-feather';
import PropTypes from 'prop-types';
import alumnosApiService from '../../services/http/alumnosApiService';
import useAuth from '../../hooks/useAuth';
import logger from '../../services/logger';

const DatosFacturas = ({ datosFacturas }) => {
  const opcionesFecha = { year: 'numeric', month: '2-digit', day: '2-digit' };
  const { getStudent } = useAuth();
  const student = getStudent() || {};
  const headquarter = student.empresaId || '';
  const userEmail = student.email || '';
  const id = student.id || '';

  const handleDownload = async (factura) => {
    try {
      const response = await alumnosApiService.crearFacturaPortalPDF({
        headquarter,
        id,
        email: false,
        emailName: userEmail,
        idFactura: factura,
      });

      if (response && typeof response === 'object' && !Array.isArray(response)) {
        const byteArray = Object.values(response);
        const uint8Array = new Uint8Array(byteArray);
        const blob = new Blob([uint8Array], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      } else {
        throw new Error('La respuesta no contiene los bytes del PDF.');
      }
    } catch (error) {
      logger.error('Error al generar el PDF:', error);
    }
  };

  if (!datosFacturas || datosFacturas.length === 0) return <p>No hay facturas disponibles.</p>;

  return (
    <TabPane tabId="3">
      <Table
        responsive
        borderless
        className="tabla-sin-fondo"
        style={{ fontSize: '13px', borderCollapse: 'separate', borderSpacing: '0 1em' }}
      >
        <thead>
          <tr>
            <th>Número Factura</th>
            <th>Fecha Factura</th>
            <th>Total Factura</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {datosFacturas.map((r) => (
            <tr key={r.n_factura}>
              <td>{r.n_factura}</td>
              <td>
                {new Intl.DateTimeFormat('es-ES', opcionesFecha).format(new Date(r.fecha_Factura))}
              </td>
              <td>{r.totalfactura} €</td>
              <td>
                <Button
                  type="button"
                  color="primary"
                  size="sm"
                  onClick={() => handleDownload(r.n_factura)}
                  style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
                >
                  <Download size={16} />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </TabPane>
  );
};

DatosFacturas.propTypes = {
  datosFacturas: PropTypes.arrayOf(
    PropTypes.shape({
      n_factura: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      fecha_Factura: PropTypes.string.isRequired,
      totalfactura: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ).isRequired,
};

export default DatosFacturas;
